/* eslint-disable max-len */
import React from 'react';

const H2Icon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
    <path
      fill="currentColor"
      d="M2.75 14.996v-4.508H7.3v4.508h1.75V5H7.3v3.976H2.75V5H1v9.996h1.75zm14.574 0v-1.428H12.55c.065-.215.187-.418.364-.609s.385-.376.623-.553c.238-.177.497-.355.777-.532.28-.177.56-.364.84-.56.28-.196.55-.406.812-.63.261-.224.495-.469.7-.735.205-.266.369-.558.49-.875.121-.317.182-.672.182-1.064 0-.317-.051-.651-.154-1.001-.103-.35-.278-.674-.525-.973-.247-.299-.572-.546-.973-.742-.401-.196-.9-.294-1.498-.294-.55 0-1.034.096-1.449.287-.415.191-.768.455-1.057.791-.29.336-.506.735-.651 1.197-.145.462-.217.964-.217 1.505h1.596c.01-.345.044-.667.105-.966.06-.299.154-.558.28-.777.126-.22.294-.392.504-.518.21-.126.474-.189.791-.189.345 0 .625.058.84.175.215.117.383.261.504.434s.203.36.245.56c.042.2.063.39.063.567-.01.383-.107.721-.294 1.015-.187.294-.425.567-.714.819-.29.252-.607.488-.952.707-.345.22-.677.446-.994.679-.663.448-1.185.975-1.568 1.582-.383.607-.579 1.316-.588 2.128h6.692z"
    />
  </svg>
);

export default H2Icon;
